"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPassageWords = void 0;
const base_1 = require("./base");
const const_1 = require("./const");
const getPassageWords = (id) => {
    return (0, base_1.get)(`${const_1.BASE_PATH}/content/get-words-by-passage-id`, true, { id });
};
exports.getPassageWords = getPassageWords;
